import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-act",
  "use": "icon-act-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-act\"><path d=\"M694.3 312.8c-114-185.5-332.1-199.3-332.1-199.3l-12.7 0.4L64 882.1l78.5 28L266.3 577c76.1-1.6 250.8 2.3 328.4 67.8 100.7 84.9 365.3-166 365.3-166s-151.6 19.4-265.7-166z\" p-id=\"3862\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol